import { AssetDTO } from './asset.dto';
import { ContestDTO } from './contest.dto';
import {
  BaseEntityDTO,
  IAssetDTO,
  IBaseEntityDTO,
  IContestDTO,
  IReleaseTypeDTO,
  ISubmissionDTO,
  ReleaseTypeDTO,
  SubmissionDTO,
} from './';

export interface IReleaseDTO extends IBaseEntityDTO {
  releaseType?: IReleaseTypeDTO;
  release?: IAssetDTO;
  contest?: IContestDTO;
  submission?: ISubmissionDTO;
  title?: string;
}

export class ReleaseDTO extends BaseEntityDTO implements IReleaseDTO {
  releaseType?: IReleaseTypeDTO;
  release?: IAssetDTO;
  contest?: IContestDTO;
  submission?: ISubmissionDTO;
  title?: string;

  constructor(data?: Partial<ReleaseDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.releaseType = data?.releaseType ? new ReleaseTypeDTO(data.releaseType) : undefined;
    this.release = data?.release ? new AssetDTO(data?.release) : undefined;
    this.contest = data?.contest ? new ContestDTO(data.contest) : undefined;
    this.submission = data?.submission ? new SubmissionDTO(data.submission) : undefined;
    this.title = data?.title || '';
  }
}
